import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import GameSubmission from './pages/GameSubmission';
import Profile from './pages/Profile';
import GamesList from './pages/GamesList';
import GameDetail from './pages/GameDetail';
import Resources from './pages/Resources';
import RankedLeague from './pages/RankedLeague';
import ScoreCalculator from './pages/ScoreCalculator';
import DiscardQuiz from './pages/DiscardQuiz';
import DecisionQuiz from './pages/DecisionQuiz';
import TournamentSubmission from './pages/TournamentSubmission';
import TournamentDetail from './pages/TournamentDetail';
import TournamentsList from './pages/TournamentsList';
import TournamentGameSubmission from './pages/TournamentGameSubmission';
import TournamentGamesAdmin from './pages/TournamentGamesAdmin';
import TournamentWaitlist from './pages/TournamentWaitlist';
import PenaltiesSearch from './pages/PenaltiesSearch';
import RoundTimer from './pages/RoundTimer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/round-timer" element={<RoundTimer />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/events" element={<Navigate to="/" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/submit-game" element={<GameSubmission />} />
                <Route path="/profile/:id" element={<Profile />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/games" element={<GamesList />} />
                <Route path="/games/:id" element={<GameDetail />} />
                <Route path="/tournaments" element={<TournamentsList />} />
                <Route path="/ranked" element={<RankedLeague />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/penalties" element={<PenaltiesSearch />} />
                <Route path="/calculator" element={<ScoreCalculator />} />
                <Route path="/discard-quiz/:discardQuizId" element={<DiscardQuiz />} />
                <Route path="/discard-quiz" element={<DiscardQuiz />} />
                <Route path="/decision-quiz/:decisionQuizId" element={<DecisionQuiz />} />
                <Route path="/decision-quiz" element={<DecisionQuiz />} />
                <Route path="/create-tournament" element={<TournamentSubmission />} />
                <Route path="/tournaments/:id/games" element={<TournamentGamesAdmin />} />
                <Route path="/tournaments/:id/waitlist" element={<TournamentWaitlist />} />
                <Route path="/tournaments/:id" element={<TournamentDetail />} />
                <Route path="/tournaments/:tournamentId/submit-game/:roundNumber/:tableNumber" element={<TournamentGameSubmission />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

